import config from '../../config'
import { HTTP } from  '../../http'
import moment from 'moment'

const pageSize = 10
const entriesEntryPointUri = config.apiEndpoints.entriesEntryPointUri
export function queryStringParamsWithPage(request, page, pageSize) {
    request.startDate = request.startDate == '' ?  '' : moment(request.startDate).format();
    request.endDate = request.endDate == '' ?  '' : moment(request.endDate).format();
    return `startDate=${request.startDate}&endDate=${request.endDate}&customerId=${request.customerId}&page=${page}&pageSize=${pageSize}`;
}
export default {
    statement: (request, page) => {
        const url = `${entriesEntryPointUri}statement?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    
}